module.exports = __webpack_public_path__ + "static/media/card-1.d1fd533f.svg";